import { ImageScaleView, ViewOpts } from '@play-co/timestep-core/ui';
import { gsap } from 'gsap';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import * as match2TournamentGetters from 'src/replicant/match2/tournament/match2-tournament.getters';
import { match2TournamentRuleset } from 'src/replicant/match2/tournament/match2-tournament.ruleset';
import { user, now } from 'src/StateObserver';

export default class Match2TournamentStreakBar extends ImageScaleView {
  private highlight?: ImageScaleView;

  constructor(opts: ViewOpts) {
    super({
      image: 'assets/ui/match2/tournament/tournament_streak_bar.png',
      width: 539,
      height: 14,
      centerOnOrigin: true,
      ...opts,
    });

    const multipliers = match2TournamentRuleset.tournamentMultiplier;
    const current = match2TournamentGetters.getTournamenCurrentMultiplierIndex(
      user(),
      now(),
    );
    const spacing = this.style.width / (multipliers.length - 1);

    for (let index = 0; index < multipliers.length; index++) {
      const multiplier = multipliers[index];
      const active = index === current;
      const size = active ? 107 : 87;
      const badge = new ImageScaleView({
        superview: this,
        image: 'assets/ui/match2/tournament/tournament_streak.png',
        width: size,
        height: size,
        centerOnOrigin: true,
        x: spacing * index,
        y: this.style.height * 0.5,
      });

      if (active) {
        this.highlight = new ImageScaleView({
          superview: badge,
          image: 'assets/ui/match2/tournament/tournament_streak_active.png',
          width: size,
          height: size,
        });
      }

      new LangBitmapFontTextView({
        superview: badge,
        centerAnchor: true,
        align: 'center',
        verticalAlign: 'center',
        size: active ? 35 : 28,
        font: 'Title',
        color: '#FFFFFF',
        width: size - 5,
        height: size - 10,
        localeText: () => `x${multiplier}`,
      });
    }
  }

  public flash() {
    if (!this.highlight) return;
    gsap.to(this.highlight.style, {
      opacity: 0,
      duration: 0.75,
      ease: 'quad.inOut',
      yoyo: true,
      repeat: -1,
    });
  }

  public unflash() {
    if (!this.highlight) return;
    gsap.killTweensOf(this.highlight.style);
  }
}
